import { useEffect, useContext, useState } from 'react';
import CommonLayout from './common-layout';
import { IAddress } from 'helpers/types';
import '../../styles/add-edit-workshop-appoitnment.scss';
import InputField from 'components/common/input-field';
import Textarea from 'components/common/textarea-field';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import {
  IAddWorkshopAppointmentRequest,
  IMedia,
  IWorkshopAppointmentCustomerData,
  requestForWorkshopAppointment,
  uploadWorkshopMedia,
} from 'store/features/workshopAppointmentsSlice';
import { AppContext } from 'context/app-context';
import Select, { IDefaultOption } from 'components/common/select';
import { initSideModal } from 'helpers/utils';
import CloudUpload from 'components/common/cloud-upload';
import { ReactComponent as CancelIcon } from 'assets/icon/cancel.svg';
import { ReactComponent as PlayIcon } from 'assets/icon/play.svg';
import { setPreviewFileData } from 'store/features/modelSlice';
import { ReactComponent as SearchIcon } from 'assets/icon/search.svg';
import toast from 'react-hot-toast';
import { getVehicleAlerts, getVehiclesList } from 'store/features/vehicleSlice';
import { IUploadImageRequestParam } from 'store/features/organizationSlice';
import { setSideModalData } from 'store/features/modelSlice';
import { IWorkshopAppointmentAddEditData } from 'interfaces/workshop-appointment-interface';
import { IVehicleAlertItem, IVehicleListItem } from 'interfaces/vehicle-interface';
import { useTranslation } from 'react-i18next';

export interface IAddEditOtherStation extends IAddress {
  isEdited?: boolean;
  index: number;
}
interface IError {
  alert_id?: string;
  vehicle_id?: string;
  other_service_type?: string;
  service_description?: string;
}

export interface IUploadMediaResponse {
  key: string;
  url: string;
  download_url: string;
}

const initWorkShopAppointmentDetails: Omit<
  IWorkshopAppointmentAddEditData,
  'appointment_date' | 'time'
> = {
  alert_id: '',
  service_description: '',
  other_service_type: '',
  special_note: '',
  user_id: '',
  user_details: null,
  vehicle_id: '',
  replace_car: false,
};

const WorkshopAppointmentRequest = () => {
  const { setLoader } = useContext(AppContext);
  const dispatch = useAppDispatch();
  const { selectedOrganization } = useAppSelector(state => state.auth);
  const { selectedVehicleALerts } = useAppSelector(state => state.vehicles);

  const {
    sideModal: {
      content: { callBackFun },
    },
  } = useAppSelector(state => state.modal);
  const [dropdownSearch, setDropdownSearch] = useState<string>('');
  const [files, setFiles] = useState<File[]>([]);
  const [error, setError] = useState<IError>({});
  const [workShopAppointment, setWorkshopAppointment] = useState<
    Omit<IWorkshopAppointmentAddEditData, 'appointment_date' | 'time'>
  >(initWorkShopAppointmentDetails);
  const [selectedVehicle, setSelectedVehicle] = useState<IVehicleListItem | null>(null);
  const [vehiclesOptions, setVehiclesOptions] = useState<IDefaultOption[]>([]);
  const { vehicles } = useAppSelector(state => state.vehicles);
  const [alertsList, setAlertList] = useState<IDefaultOption[]>([]);
  const { t } = useTranslation();

  const fetchVehicles = () => {
    setLoader(true);
    const params: { company_id: string[] } = {
      company_id: [
        ...(selectedOrganization?.associated_company_id
          ? [selectedOrganization.associated_company_id]
          : []),
      ],
    };
    dispatch(getVehiclesList({ request: params }))
      .catch(() => {})
      .then(() => setLoader(false))
      .catch(() => setLoader(false));
  };
  const fetchData = async () => {
    try {
      await fetchVehicles();
    } catch (error) {
      setLoader(false);
    }
  };
  useEffect(() => {
    try {
      setLoader(true);
      fetchData();
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  }, []);
  const setVehicleData = async () => {
    try {
      setLoader(true);
      const respponse: IVehicleAlertItem[] = await dispatch(
        getVehicleAlerts({
          vehicle_id: workShopAppointment?.vehicle_id,
          params: { status: 'alert' },
        }),
      ).catch(() => setLoader(false));
      const formatedOption = respponse.map(data => ({
        id: data?._id,
        _id: data?._id,
        name: `${data?.alert_ref === undefined ? '' : data?.alert_ref} ${data?.title}`,
        value: data?._id,
      }));
      const selectedVeh: IVehicleListItem | null =
        [...vehicles].find(data => data?._id === workShopAppointment?.vehicle_id) || null;
      setSelectedVehicle(selectedVeh);
      setAlertList([
        ...formatedOption,
        { id: 'OTHER', _id: 'OTHER', name: 'Other', value: 'OTHER' },
      ]);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  useEffect(() => {
    try {
      setLoader(true);
      const updatedOptions: IDefaultOption[] = (vehicles || []).map(data => ({
        id: data?._id || '',
        name: `${data?.model} (${data?.plate})` || '',
        value: data?.plate,
      }));
      setVehiclesOptions(updatedOptions);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  }, [vehicles]);
  useEffect(() => {
    if (workShopAppointment?.vehicle_id) setVehicleData();
  }, [workShopAppointment?.vehicle_id]);
  const handleChange = (field: string, value: string | IWorkshopAppointmentCustomerData | null) => {
    setWorkshopAppointment({ ...workShopAppointment, [field]: value });
  };
  const getErrorData = () => {
    return {
      alert_id: !workShopAppointment?.alert_id?.trim()
        ? t('workshopAppointment.add_edit.error_alert_toast_message')
        : '',
      vehicle_id: !workShopAppointment?.vehicle_id?.trim()
        ? t('workshopAppointment.add_edit.error_customer_toast_message')
        : '',
      service_description: !workShopAppointment?.service_description?.trim()
        ? t('workshopAppointment.add_edit.error_service_description')
        : '',
    };
  };
  const isValid = () => {
    if (
      !workShopAppointment?.alert_id?.trim() ||
      !workShopAppointment?.vehicle_id?.trim() ||
      !workShopAppointment?.service_description?.trim()
    ) {
      const output = getErrorData();
      setError(output);
      return false;
    } else if (
      workShopAppointment?.alert_id === 'OTHER' &&
      !workShopAppointment?.other_service_type?.trim()
    ) {
      setError({
        ...error,
        other_service_type: !workShopAppointment?.other_service_type?.trim()
          ? t('workshopAppointment.add_edit.error_other_service_toast_message')
          : '',
      });
      return false;
    } else {
      const output = getErrorData();
      setError(output);
      return true;
    }
  };
  const uploadMediaForAdd = async () => {
    try {
      const uploadMediaParam =
        files.map(data => {
          return {
            request: {
              file_name: data?.name || '',
              file_type: data?.type || '',
              file_size: data?.size || 0,
            },
            file: data,
          };
        }) || [];
      const mediaResponse: IUploadMediaResponse[] = await Promise.all(
        [...uploadMediaParam].map(data => {
          const params: IUploadImageRequestParam = {
            request: {
              file_name: data?.request?.file_name || '',
              file_type: data?.request?.file_type || '',
              file_size: data?.request?.file_size || 0,
            },
            file: data?.file,
          };
          const res = dispatch(uploadWorkshopMedia({ params }));
          return res;
        }),
      );
      return Promise.resolve(mediaResponse);
    } catch (error) {
      return Promise.reject(error);
    }
  };
  const getRequestData = async () => {
    const uploadMedia = await uploadMediaForAdd().catch(err => {
      return;
    });
    let request: IAddWorkshopAppointmentRequest = {
      service_description: workShopAppointment?.service_description || '',
      media: uploadMedia?.length ? uploadMedia.map(data => data?.key || '') : [],
      vehicle_id: workShopAppointment?.vehicle_id || '',
      replace_car: false,
      type: selectedOrganization?.role_name || '',
    };
    if (selectedVehicle?.assigned_user_Id) {
      request = { ...request, user_id: selectedVehicle?.assigned_user_Id || '' };
    }
    if (workShopAppointment?.alert_id === 'OTHER') {
      request = { ...request, other_service_type: workShopAppointment?.other_service_type || '' };
    } else {
      request = { ...request, alert_id: workShopAppointment?.alert_id || '' };
    }
    if (workShopAppointment?.special_note) {
      request = { ...request, special_note: workShopAppointment?.special_note || '' };
    }
    return request;
  };
  const handleSendWorkshopAppointmentRequest = async () => {
    try {
      setLoader(true);
      const request = await getRequestData();
      dispatch(requestForWorkshopAppointment({ request: { ...request } }))
        .then(() => {
          callBackFun && callBackFun();
          toast.success(t('workshopAppointment.success_appointment_request_send_toast_message'));
          dispatch(setSideModalData(initSideModal));
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
        });
    } catch (error) {
      setLoader(false);
    }
  };
  const handleSubmit = () => {
    try {
      if (!isValid()) {
        return;
      }
      handleSendWorkshopAppointmentRequest();
    } catch (error) {}
  };
  const handlePreviewFile = (file: File, type: string) => {
    dispatch(
      setPreviewFileData({
        type: type || '',
        content: { url: window.URL.createObjectURL(file) },
      }),
    );
  };
  const getFileContent = (file: File) => {
    const splitedVal = file.type.split('/');
    switch (splitedVal[0]) {
      case 'image':
        return (
          <img
            src={window.URL.createObjectURL(file)}
            className="flex items-center justify-center min-w-full h-full w-12 object-contain"
            alt=""
            onClick={() => handlePreviewFile(file, splitedVal[0])}
          />
        );
      case 'video':
        return (
          <div
            className="flex items-center justify-center bg-grey3 w-12 h-full min-w-full rounded-3 cursor-pointer"
            onClick={() => handlePreviewFile(file, splitedVal[0])}
          >
            <PlayIcon />
          </div>
        );
      default:
        return (
          <div
            className="flex items-center justify-center bg-grey1 w-full h-full rounded-3 cursor-pointer"
            onClick={() => handlePreviewFile(file, splitedVal[0])}
          >
            <SearchIcon />
          </div>
        );
    }
  };
  const getAddedFileContent = (file: IMedia) => {
    const splitedVal = file.type.split('/');
    const handleShowFile = () => {
      dispatch(
        setPreviewFileData({
          type: file.type || '',
          content: { url: file.url },
        }),
      );
    };
    switch (splitedVal[0]) {
      case 'image':
        return (
          <img
            src={file.url}
            className="flex items-center justify-center min-w-full h-full w-12 object-contain"
            alt=""
            onClick={() => handleShowFile()}
          />
        );
      case 'video':
        return (
          <div
            className="flex items-center justify-center bg-grey3 w-12 h-full min-w-full rounded-3 cursor-pointer"
            onClick={() => handleShowFile()}
          >
            <PlayIcon />
          </div>
        );
      default:
        return (
          <div
            className="flex items-center justify-center bg-grey1 w-full h-full rounded-3 cursor-pointer"
            onClick={() => handleShowFile()}
          >
            <SearchIcon />
          </div>
        );
    }
  };
  const handleSetFiles = (file: File) => {
    const updatedFiles = [...files, file];
    setFiles(updatedFiles);
  };
  const handleRemoveFiles = (index: number) => {
    const updatedFiles = (files || []).filter((file, i) => i !== index);
    setFiles(updatedFiles);
  };
  return (
    <CommonLayout
      onConfirm={() => handleSubmit()}
      confirmButtonProps={{ label: t('workshopAppointment.add_edit.schedule') }}
    >
      <div className={`flex flex-col w-full h-full p-6`}>
        <div className="flex flex-wrap w-full -mx-3">
          <div className="flex flex-wrap w-full">
            <div className="w-full px-3">
              <CloudUpload
                title={t('FILE_TITLE')}
                setFile={e => {
                  if (e?.target?.files?.length) {
                    handleSetFiles(e?.target?.files[0]);
                  } else {
                    e.stopPropagation();
                  }
                }}
                acceptedFile={'image/*,video/*'}
              />
            </div>
            <div className="w-full flex items-center justify-start px-3 mt-3 overflow-hidden">
              <div className="overflow-x-auto w-full max-w-full flex py-2">
                {workShopAppointment?.media?.length ? (
                  workShopAppointment?.media.map((file, index) => (
                    <div
                      className="flex items-center justify-center ml-2 rounded-3 h-12 w-12 max-w-12 min-h-full min-w-fit bg-grey1 relative"
                      key={`${file._id}-${index}`}
                    >
                      <CancelIcon
                        className="flex absolute -top-1 -right-1 cursor-pointer"
                        onClick={() => {
                          const updatedMediaFile = workShopAppointment?.media?.filter(
                            data => data?._id !== file?._id,
                          );
                          setWorkshopAppointment({
                            ...workShopAppointment,
                            media: updatedMediaFile,
                          });
                        }}
                      />
                      {getAddedFileContent(file)}
                    </div>
                  ))
                ) : (
                  <></>
                )}
                {files && files?.length ? (
                  files.map((file, index) => (
                    <div
                      className="flex items-center justify-center ml-2 rounded-3 h-12 w-12 max-w-12 min-h-full min-w-fit bg-grey1 relative"
                      key={`${file?.name}-${index}`}
                    >
                      <CancelIcon
                        className="flex absolute -top-1 -right-1 cursor-pointer"
                        onClick={() => handleRemoveFiles(index)}
                      />
                      {getFileContent(file)}
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          <div className="w-full mt-2 px-3 mb-3">
            <label className="text-base font-bold">{t('workshopAppointment.add_edit.title')}</label>
          </div>
          <div className="w-1/2 px-3">
            <div className="mb-3">
              <label className="font-medium text-sm text-black2 w-full">
                {t('workshopAppointment.add_edit.vehicle')}
              </label>
              <Select
                placeholder={t('workshopAppointment.add_edit.placeholder_vehicle')}
                options={vehiclesOptions.filter(
                  coun =>
                    coun?.value && coun?.value.toLowerCase().includes(dropdownSearch.toLowerCase()),
                )}
                selected={
                  vehiclesOptions?.find(data => data?.id === workShopAppointment?.vehicle_id) ||
                  null
                }
                setSelected={data => handleChange('vehicle_id', data?.id)}
                disabled={false}
                error={error?.vehicle_id}
                isSearchable
                removeSearchOnBlur
                search={dropdownSearch}
                setSearch={val => setDropdownSearch(val)}
              />
            </div>
          </div>
          <div className="w-1/2 px-3"></div>
          <div className="w-1/2 px-3">
            <div className="mb-3">
              <label className="font-medium text-sm text-black2 w-full">
                {t('workshopAppointment.add_edit.alert')}
              </label>
              <Select
                placeholder={t('workshopAppointment.add_edit.placeholder_alert')}
                options={alertsList.filter(
                  coun => coun?.name.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
                )}
                selected={
                  alertsList?.find(data => data?._id === workShopAppointment?.alert_id) || null
                }
                setSelected={data => {
                  const selAlert = selectedVehicleALerts.find(
                    a => a._id === (data?._id || data?.id),
                  );
                  setWorkshopAppointment({
                    ...workShopAppointment,
                    alert_id: data?._id || data?.id,
                    service_description: selAlert ? selAlert?.description : '',
                  });
                }}
                disabled={!workShopAppointment?.vehicle_id}
                error={error?.alert_id || ''}
                isSearchable
                removeSearchOnBlur
                search={dropdownSearch}
                setSearch={val => setDropdownSearch(val)}
              />
            </div>
          </div>
          <div className="w-1/2 px-3">
            {workShopAppointment?.alert_id === 'OTHER' && (
              <div className="mb-3">
                <label className="font-medium text-sm text-black2 w-full">
                  {t('workshopAppointment.add_edit.service_type')}
                </label>
                <InputField
                  placeholder={t('workshopAppointment.add_edit.service_type')}
                  value={workShopAppointment?.other_service_type || ''}
                  onChange={val => handleChange('other_service_type', val)}
                  error={error?.other_service_type || ''}
                />
              </div>
            )}
          </div>
          <div className="w-1/2 px-3">
            <div className="mb-3">
              <label className="font-medium text-sm text-black2 w-full">
                {t('workshopAppointment.add_edit.service_description')}
              </label>
              <Textarea
                placeholder={t('workshopAppointment.add_edit.service_description')}
                value={workShopAppointment?.service_description}
                onChange={val => handleChange('service_description', val)}
                error={error?.service_description || ''}
                row={2}
              />
            </div>
          </div>
          <div className="w-1/2 px-3">
            <div className="mb-3">
              <label className="font-medium text-sm text-black2 w-full">
                {t('workshopAppointment.add_edit.note')}
              </label>
              <Textarea
                placeholder={t('workshopAppointment.add_edit.placeholder_note')}
                value={workShopAppointment?.special_note || ''}
                onChange={val => handleChange('special_note', val)}
                row={2}
              />
            </div>
          </div>
          <div className="w-1/2 px-3">
            <div className="mb-3">
              <label className="font-medium text-sm text-black2 w-full">
                {t('workshopAppointment.add_edit.placeholder_customer')}
              </label>
              <InputField
                placeholder={t('workshopAppointment.add_edit.placeholder_customer')}
                value={selectedVehicle?.assigned_user_name || ''}
                onChange={val => {}}
                error={''}
                disabled
              />
            </div>
          </div>
          <div className="w-1/2 px-3">
            <div className="mb-3">
              <label className="font-medium text-sm text-black2 w-full">
                {t('workshopAppointment.ExpandedUi.vehicle_plate')}
              </label>
              <InputField
                placeholder={t('workshopAppointment.ExpandedUi.vehicle_plate')}
                value={selectedVehicle?.plate || ''}
                onChange={val => {}}
                error={''}
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </CommonLayout>
  );
};

export default WorkshopAppointmentRequest;
